import { render, staticRenderFns } from "./ResetForm.vue?vue&type=template&id=7b935f36&scoped=true&"
import script from "./ResetForm.vue?vue&type=script&lang=ts&"
export * from "./ResetForm.vue?vue&type=script&lang=ts&"
import style0 from "./ResetForm.vue?vue&type=style&index=0&id=7b935f36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b935f36",
  null
  
)

export default component.exports